module.exports = __webpack_public_path__ + "static/media/menu_bottom_logo.5e849f93.svg";